<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header & ADD Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Checker IT Facility</h4>
        
      </div>

      <!-- Employee Table -->
       <div class="table-responsive modern-table-container">
  <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Emp Code</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Department</th>
            <th>Asset Type</th>
            <th>NAC Drive Access</th>
            <th>Dongle Sim</th>
            <th>Mobile Sim</th>
            <th>BioMetric Card</th>
            <th>Door Access</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.checkeritfacilitygrid; let i = index">
            <!-- Index -->
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td class="text-center"><div class="Dropdown">
              <button class="icon-button me-1" ([ngModel])="appservice.checkeritfacilityedit" (click)="editEmployee(emp.IR_EmployeeId)" title="Edit">
    <img src="assets/images/edit.png" alt="Edit" width="20" height="20">
  </button>
  </div>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.IR_EmployeeId }}</td>
            <td>{{ emp.IR_Fullname }}</td>
            <td>{{ emp.IR_Designation }}</td>
            <td>{{ emp.IR_Grade }}</td>
            <td>{{ emp.IR_Department }}</td>
            <td>{{ emp.IR_AssertType }}</td>
            <td>{{ emp.IR_NacDriver_Access }}</td>
            
            <td>{{ emp.IR_Dongle_SimCard }}</td>
            <td>{{ emp.IR_Mobilesim }}</td>
            <td>{{ emp.IR_Biometric_card }}</td>
            <td>{{ emp.IR_DoorAccess }}</td>
          </tr>
        </tbody>
      </table>
</div>
    </div>
  </div>
</div>
